import React from 'react';

const BillingSettings = () => {
  return (
    <div className="billing-settings-container">
      <h3 className="billing-title">Payment Methods</h3>
      <div className="billing-content">
        <div className="billing-sidebar">
          <p className="billing-card-details-title">Card Details</p>
          <p className="billing-card-details-subtext">Update your billing details</p>
          <button className="billing-add-card-btn">Add another card</button>
        </div>

        <div className="billing-form">
          <div className="billing-form-group">
            <label>Name on your card</label>
            <input type="text" value="Brian" readOnly />
          </div>
          <div className="billing-form-group">
            <label>Expiry</label>
            <input type="text" value="Frederin" readOnly />
          </div>
          <div className="billing-form-group">
            <label>Card Number</label>
            <input type="text" value="8298 9870 9234 XXXX" readOnly />
          </div>
          <div className="billing-form-group">
            <label>CVV</label>
            <input type="text" value="****" readOnly />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingSettings;
